export const APP_NAME = '阿里云智算中心'
